





























































import { Either, Left } from 'fp-ts/lib/Either'
import _ from 'lodash'
import superagent from 'superagent'

import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

import { log } from '@/log'
import { RawTag as Tags } from '@/models/api/tags'

import LoadingMixin, { Status } from '@spa/mixins/loading'

import { PluginMixin } from '@spa/mixins/plugin'
import { MailMagazineService } from '@spa/services/mailMagazine'
import { UserValidator } from '@spa/validation/user'

import SpaCharacter from '@/components/organisms/Character.vue'
import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
/*
 * TDOO: @spa/components/organisms/mail-magazine/MailMagazine.vueを使う
 *
 * メールマガジン情報の取得がコンポーネントに閉じ込められ、完了/失敗の検知がイベント経由になったので、
 * 前段のユーザー情報取得処理の結果（完了/失敗）と併せての取り扱い方にちょっと工夫が必要そう.
 *
 * 一端このままにして、次回以降のスプリントで共通化対応.
 */
import MailMagazineCheckList from '@spa/components/organisms/mail-magazine/MailMagazineCheckList.vue'
import BackToMyPageTopButton from '@spa/components/organisms/mypage/BackToMypPageTopButton.vue'

@Component({
  components: {
    SpaCharacter,
    SpaErrorDialog,
    MailMagazineCheckList,
    BackToMyPageTopButton,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class ChangeMailMagazine extends Mixins<PluginMixin>(PluginMixin) {
  pageStatus: Status = Status.Pending

  submitStatus: Status = Status.Pending

  validator: UserValidator = new UserValidator()

  showModal: boolean = false

  modalMessage: string = ''

  mailMagazineList: Tags[] = []

  mailMagazineUpdateError: Error | null = null

  mailMagazineService = new MailMagazineService()

  behaviorConfig = new BehaviorConfig()

  get isLoading(): boolean {
    return this.pageStatus === Status.Loading || this.isSubmitLoading
  }

  get isPageCompleted(): boolean {
    return this.pageStatus === Status.Completed
  }

  get isSubmitLoading(): boolean {
    return this.submitStatus === Status.Loading
  }

  get isSubmitCompleted(): boolean {
    return this.submitStatus === Status.Completed
  }

  get isSubmitFailed(): boolean {
    return this.submitStatus === Status.Failed || this.isUpdateMailMagazineFailed
  }

  get isUpdateMailMagazineFailed(): boolean {
    return this.mailMagazineUpdateError !== null
  }

  get errorOnLoad() {
    return _.get(this.$store.state.user, 'error.get')
  }

  get errorOnUpdate() {
    return _.get(this.$store.state.user, 'error.update')
  }

  async created() {
    this.pageStatus = Status.Loading

    try {
      await this.initUserAndMailMagazine()
      this.pageStatus = Status.Completed
    } catch (e) {
      log.error(e)
      this.pageStatus = Status.Failed
    }

  }

  async submit() {

    this.$nextTick(() => {
      window.scrollTo(0, 0)
    })

    this.submitStatus = Status.Loading

    const updateMailMagazine = this.updateMailMagazinesState().then((updateMailMagazinesState) => {
      if (updateMailMagazinesState.isLeft()) {
        this.mailMagazineUpdateError = updateMailMagazinesState.value
        this.submitStatus = Status.Failed

        return
      }
      this.mailMagazineUpdateError = null
    })

    await Promise.all([updateMailMagazine])

    if (this.submitStatus as Status !== Status.Failed) {
      this.submitStatus = Status.Completed
    }
  }

  async initUserAndMailMagazine(): Promise<void> {
    await this.$store.dispatch('user/get', { force: true })

    const user = this.$store.state.user.user
    if (!user || this.errorOnLoad) {
      this.modalMessage = 'お客様情報が取得できませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
      this.showModal = true
      this.pageStatus = Status.Failed

      throw new Error('failed to get user.')
    }

    const magazineState = await this.mailMagazineService.listAsUser({
      with: 'follow',
    })
    if (magazineState.isLeft()) {
      this.modalMessage = 'メールマガジン情報が取得できませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
      this.showModal = true
      this.pageStatus = Status.Failed

      throw new Error('failed to get mail magazine.')
    }
    this.mailMagazineList = magazineState.value
  }

  updateMailMagazinesState(): Promise<Either<Error, superagent.Response>> {
    const user = this.$store.state.user.user

    if (user === null) {
      return Promise.resolve(new Left(new Error('user not found')))
    }
    const userId = user.id
    const [shouldFollowMagazines, shouldUnfollowMagazines] = _.partition(this.mailMagazineList, 'follow')

    return this.mailMagazineService.changeSubscriptionStatus(
      userId,
      shouldFollowMagazines.map(m => m.pathname),
      shouldUnfollowMagazines.map(m => m.pathname)
    )
  }

  onChangeMagazine(checkedIndex: number, checkedItem: Tags) {
    this.mailMagazineList[checkedIndex] = checkedItem
  }
}
